import type { SidePanel } from '../types';

export const ChooseInvestorAutoPanel: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./ChooseInvestorAutoPanel.vue')),
};
